(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["read-more-rich-text-item"] && !Shopify.designMode) return;
  try {
    class ReadMoreInline extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.expanded = false;

      this.collapsed = this.querySelector('[data-read-more-collapsed]');
      this.shortText = this.querySelector('[data-read-more-short-text]');
      this.full = this.querySelector('[data-read-more-full]');
      this.expandButton = this.querySelector('[data-read-more-expand]');
      this.collapseButton = this.querySelector('[data-read-more-collapse]');

      if (!this.collapsed || !this.shortText || !this.full || !this.expandButton) return;

      const breakpoint = parseInt(this.dataset.breakpoint, 10) || 749;

      this.mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);

      this.expandButton.addEventListener('click', () => {
        this.expanded = true;
        this.updateVisibility();
      });

      if (this.collapseButton) {
        this.collapseButton.addEventListener('click', () => {
          this.expanded = false;
          this.updateVisibility();
        });
      }

      this.renderReadMore = this.renderReadMore.bind(this);

      if (this.mediaQuery.addEventListener) {
        this.mediaQuery.addEventListener('change', this.renderReadMore);
      } else {
        this.mediaQuery.addListener(this.renderReadMore);
      }

      this.renderReadMore();
    }

    getLimit() {
      const desktopLimit = parseInt(this.dataset.desktopLimit, 10) || 180;
      const mobileLimit = parseInt(this.dataset.mobileLimit, 10) || desktopLimit;

      return this.mediaQuery.matches ? mobileLimit : desktopLimit;
    }

    getFullText() {
      const fullClone = this.full.cloneNode(true);
      const lessButton = fullClone.querySelector('[data-read-more-collapse]');

      if (lessButton) {
        lessButton.remove();
      }

      return fullClone.textContent.replace(/\s+/g, ' ').trim();
    }

    renderReadMore() {
      const limit = this.getLimit();
      const fullText = this.getFullText();

      if (fullText.length <= limit) {
        this.needsCollapse = false;
        this.collapsed.hidden = true;
        this.full.hidden = false;

        if (this.collapseButton) {
          this.collapseButton.hidden = true;
        }

        return;
      }

      this.needsCollapse = true;

      let shortenedText = fullText.substring(0, limit);
      shortenedText = shortenedText.replace(/\s+\S*$/, '');

      this.shortText.textContent = shortenedText;

      if (this.collapseButton) {
        this.collapseButton.hidden = false;
      }

      this.updateVisibility();
    }

    updateVisibility() {
      if (!this.needsCollapse) {
        this.collapsed.hidden = true;
        this.full.hidden = false;
        return;
      }

      if (this.expanded) {
        this.collapsed.hidden = true;
        this.full.hidden = false;
      } else {
        this.collapsed.hidden = false;
        this.full.hidden = true;
      }
    }
  }

  if (!customElements.get('read-more-inline')) {
    customElements.define('read-more-inline', ReadMoreInline);
  }
  } catch(e) { console.error(e); }
})();

})();
